import { spacing } from '@gyym/ui'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  /* mobile viewport bug fix */
  @supports (-webkit-touch-callout: none) {
    min-height: -webkit-fill-available;
  }
  position: relative;
`

interface ContentProps {
  topPadded: boolean
}

export const Content = styled.main<ContentProps>`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding-top: ${({ topPadded }) => (topPadded ? spacing(14) : 0)};
`
